import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "providers/AuthProvider";
import { usePasskeyAuthentication } from "./usePasskeyAuthentication";

export const usePasskeyLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { authenticate, isLoading } = usePasskeyAuthentication();

  const loginWithPasskey = useCallback(async () => {
    const authentication = await authenticate();

    if (!authentication.success) return;

    login(
      authentication.userId,
      authentication.token
    );

    navigate("/");
  }, [authenticate, login, navigate]);

  return {
    loginWithPasskey,
    isLoading,
  };
};